module.exports = __webpack_public_path__ + "src/assets/img/tabular-figures@2x.f130a8a.png";